// @flow
import { combineReducers } from 'redux';
import {
  STORE_PDB_DATA,
  SET_ACTIVE_PDB_ITEM,
  GET_PDB_DATA_SUCCESS,
} from './constants';
import type {
  PdbState,
  StorePdbData,
  FetchPdbDataSuccess,
  SetActivePdbItem,
  ActivePdbState,
  State,
} from './types';

const initialState: State = {
  activePdbId: null,
  items: {},
};

const activePdbId = (
  state = initialState.activePdbId,
  action: SetActivePdbItem,
): ?ActivePdbState => {
  switch (action.type) {
    case SET_ACTIVE_PDB_ITEM:
      return action.id;
    default:
      return state;
  }
};

const items = (
  state = initialState.items,
  action: StorePdbData | FetchPdbDataSuccess,
): PdbState => {
  switch (action.type) {
    case GET_PDB_DATA_SUCCESS: {
      const { pdb } = action.payload;
      if (!pdb) {
        return state;
      }

      // $FlowFixMe
      return {
        ...state,
        ...pdb,
      };
    }
    case STORE_PDB_DATA: {
      const pdb = action.payload;
      if (!pdb) {
        return state;
      }

      // $FlowFixMe
      return {
        ...state,
        ...pdb,
      };
    }
    default:
      return state;
  }
};

export default combineReducers<Object, Object>({
  items,
  activePdbId,
});
